export const PROPOSAL_FETCH_REQUESTED = 'PROPOSAL_FETCH_REQUESTED'
export const PROPOSAL_FETCH_SUCCESS = 'PROPOSAL_FETCH_SUCCESS'
export const USERS_FETCH_REQUESTED = 'USERS_FETCH_REQUESTED'
export const PROPOSAL_CREATE_REQUESTED = 'PROPOSAL_CREATE_REQUESTED'
export const PROPOSAL_CREATE_SUCCESS = 'PROPOSAL_CREATE_SUCCESS'
export const PROPOSAL_UPDATE_REQUESTED = 'PROPOSAL_UPDATE_REQUESTED'
export const PROPOSAL_UPDATE_SUCCESS = 'PROPOSAL_UPDATE_SUCCESS'
export const PROPOSAL_REPLACE_FILE_REQUESTED = 'PROPOSAL_REPLACE_FILE_REQUESTED'
export const PROPOSAL_REPLACE_FILE_SUCCESS = 'PROPOSAL_REPLACE_FILE_SUCCESS'
export const PROPOSAL_UPDATE_FILE_REQUESTED = 'PROPOSAL_UPDATE_FILE_REQUESTED'
export const PROPOSAL_UPDATE_FILE_SUCCESS = 'PROPOSAL_UPDATE_FILE_SUCCESS'
export const PROPOSALS_ROW_DATA_FETCH_REQUESTED = 'PROPOSALS_ROW_DATA_FETCH_REQUESTED'
export const PROPOSALS_BOARD_ROW_DATA_FETCH_REQUESTED = 'PROPOSALS_BOARD_ROW_DATA_FETCH_REQUESTED'
export const PROPOSAL_UPDATE_STATUS_REQUESTED = 'PROPOSAL_UPDATE_STATUS_REQUESTED'
export const PROPOSAL_UPDATE_STATUS_SUCCESS = 'PROPOSAL_UPDATE_STATUS_SUCCESS'
export const PROPOSAL_TASKS_FETCH_REQUESTED = 'PROPOSAL_TASKS_FETCH_REQUESTED'
export const PROPOSAL_TASKS_FETCH_SUCCESS = 'PROPOSAL_TASKS_FETCH_SUCCESS'
export const PROPOSAL_TASK_MARK_COMPLETED_REQUESTED = 'PROPOSAL_TASK_MARK_COMPLETED_REQUESTED'
export const PROPOSAL_TASK_MARK_COMPLETED_SUCCESS = 'PROPOSAL_TASK_MARK_COMPLETED_SUCCESS'
export const PROPOSAL_TASK_MARK_NOT_COMPLETED_REQUESTED =
  'PROPOSAL_TASK_MARK_NOT_COMPLETED_REQUESTED'
export const PROPOSAL_TASK_MARK_NOT_COMPLETED_SUCCESS = 'PROPOSAL_TASK_MARK_NOT_COMPLETED_SUCCESS'
export const UPDATE_PROPOSAL_TASK_REQUESTED = 'UPDATE_PROPOSAL_TASK_REQUESTED'
export const UPDATE_PROPOSAL_TASK_SUCCESS = 'UPDATE_PROPOSAL_TASK_SUCCESS'
export const CREATE_PROPOSAL_TASK_REQUESTED = 'CREATE_PROPOSAL_TASK_REQUESTED'
export const CREATE_PROPOSAL_TASK_SUCCESS = 'CREATE_PROPOSAL_TASK_SUCCESS'
export const UPDATE_PROPOSAL_HTML_REQUESTED = 'UPDATE_PROPOSAL_HTML_REQUESTED'
export const UPDATE_PROPOSAL_HTML_SUCCESS = 'UPDATE_PROPOSAL_HTML_SUCCESS'
export const COMPANY_CONTACTS_FETCH_REQUESTED = 'COMPANY_CONTACTS_FETCH_REQUESTED'
export const CHANGE_EMAIL_CONTACTS = 'CHANGE_EMAIL_CONTACTS'
export const EMAIL_PROPOSAL_TO_CLIENT_REQUESTED = 'EMAIL_PROPOSAL_TO_CLIENT_REQUESTED'
export const EMAIL_PROPOSAL_TO_CLIENT_SUCCESS = 'EMAIL_PROPOSAL_TO_CLIENT_SUCCESS'
export const RESET_EMAIL_CONTACTS = 'RESET_EMAIL_CONTACTS'
export const DELETE_PROPOSAL_TASK_REQUESTED = 'DELETE_PROPOSAL_TASK_REQUESTED'
export const DELETE_PROPOSAL_TASK_SUCCESS = 'DELETE_PROPOSAL_TASK_SUCCESS'
export const PROPOSAL_APPROVE_REQUESTED = 'PROPOSAL_APPROVE_REQUESTED'
export const PROPOSAL_APPROVE_SUCCESS = 'PROPOSAL_APPROVE_SUCCESS'
export const PROPOSAL_CONTACTS_HISTOY_FETCH_REQUESTED = 'PROPOSAL_CONTACTS_HISTOY_FETCH_REQUESTED'
export const PROPOSAL_CONTACTS_HISTOY_FETCH_SUCCESS = 'PROPOSAL_CONTACTS_HISTOY_FETCH_SUCCESS'
export const CLEAR_PROPOSAL_FROM_STORE = 'CLEAR_PROPOSAL_FROM_STORE'
export const PROPOSAL_SEND_FOR_REVIEW_REQUESTED = 'PROPOSAL_SEND_FOR_REVIEW_REQUESTED'
export const PROPOSAL_SEND_FOR_REVIEW_SUCCESS = 'PROPOSAL_SEND_FOR_REVIEW_SUCCESS'
export const SHOW_PROPOSAL_FOLLOWUP = 'SHOW_PROPOSAL_FOLLOWUP'
export const ADD_FILE = 'ADD_FILE'
export const REMOVE_FILE = 'REMOVE_FILE'
export const DASHBOARD_UPDATE_NEW_PROPOSALS_COUNTER = 'DASHBOARD_UPDATE_NEW_PROPOSALS_COUNTER'
export const PROPOSAL_DELETE_REQUESTED = 'PROPOSAL_DELETE_REQUESTED'
export const PROPOSAL_DELETE_SUCCESS = 'PROPOSAL_DELETE_SUCCESS'
